<!-- 个人中心 -->
<template>
  <div class="pageView">
    <PCNavbar />
    <div style="position: relative;">
      <CarouselHome ref="carouselHomeRef" type="user_center" slot=""/>
      <div class="mask" style="height: 100%;">
        <div class="block-wrap flex-center">
          <div class="person">
            <div class="head">
              <img v-if="userInfo.avatar.length > 0" class="avatar" :src="userInfo.avatar" />
              <img v-else class="avatar" src="@/assets/images/defaultHead.png" />
              <div class="edit" @click="handleEdit">
                <img class="edit-icon" src="@/assets/images/edit.png" />
              </div>
            </div>
            <div class="info">{{ userInfo.nickname }}</div>
            <!--<div class="info">{{ userInfo.username }}</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="main-wrap">
      <div class="block-wrap" v-if="edit">
        <div class="article" style="margin-top: 50px">
          <h3 class="h3">用户信息</h3>
          <el-form class="form" ref="formRef" :model="form" label-position="top">
            <el-form-item label="账号">
              <el-input v-model="userInfo.username" readonly placeholder="请输入账号" />
            </el-form-item>
            <el-form-item label="用户名" prop="nickname">
              <el-input v-model="form1.nickname" placeholder="请输入用户名" maxlength="10" />
            </el-form-item>
            <el-form-item label="头像" prop="avatar">
              <div class="flex-start-end">
                <div class="pictrue flex-center">
                  <img v-if="form1.avatar.length > 0" :src="form1.avatar" />
                  <img v-else src="@/assets/images/pictrue.png" />
                </div>
                <el-upload
                  v-model="fileList"
                  class="upload-demo"
                  :action="uploadUrl"
                  :limit="1"
                  :show-file-list="false"
                  :headers="{ token: userInfo.token }"
                  :before-upload="beforeUpload"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                >
                  <el-button class="btn" style="width: auto; height: auto" icon="el-icon-document-add">点击上传</el-button>
                  <template #tip>
                    <div class="el-upload-tip"><i class="el-icon-warning-outline" /> 建议图片格式为.jpg/.png/.jpeg，图片大小不超过30M</div>
                    <div class="el-upload-tip"><i class="el-icon-warning-outline" /> 选择文件（1个）</div>
                  </template>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="custom-btn-group">
          <el-button class="btn" @click="handleSubmit">保存并提交</el-button>
        </div>
      </div>
      <div class="block-wrap" v-else>
        <div class="tab">
          <div class="tab-item" :class="{ current: current == 1 }" @click="toggle(1)">捐赠记录</div>
          <div class="tab-item" :class="{ current: current == 2 }" @click="toggle(2)">票据申领</div>
          <div class="tab-item" :class="{ current: current == 3 }" @click="toggle(3)">证书申领</div>
          <div class="tab-item" :class="{ current: current == 4 }" @click="toggle(4)">志愿活动</div>
        </div>
        <div class="article" v-show="current !== 4">
          <h3 class="h3" v-show="current == 1">捐赠记录</h3>
          <h3 class="h3" v-show="current == 2">票据申领</h3>
          <h3 class="h3" v-show="current == 3">证书申领</h3>
          <div class="list">
            <div class="list-row" v-for="(item, index) in list" :key="index">
              <div class="wrap">
                <div class="title">{{ item?.project?.title }}</div>
                <div class="flex-space-between">
                  <div class="left">
                    <div class="row">
                      <div class="label">捐赠人：</div>
                      <div class="text">{{ item.name }}</div>
                    </div>
                    <div class="row">
                      <div class="label">捐赠金额：</div>
                      <div class="text">{{ item.price }} 元</div>
                    </div>
                    <div class="row">
                      <div class="label">支付方式：</div>
                      <div class="text">{{ item.pay_type }}</div>
                    </div>
                    <div class="row">
                      <div class="label">捐赠平台：</div>
                      <div class="text">{{ item.platform }}</div>
                    </div>
                    <div class="row">
                      <div class="label">捐赠时间：</div>
                      <div class="text">{{ item.pay_time_text }}</div>
                    </div>
                  </div>
                  <div class="right" v-if="current > 1">
                    <template v-if="current == 2">
                      <el-button class="btn" v-if="current == 2 && item.fapiao_is_apply == 0" @click="apply(item)">申领</el-button>
                      <el-button class="btn" disabled v-if="current == 2 && item.fapiao_is_apply == 1 && item.fapiao_status == 0">申领中</el-button>
                      <el-button class="btn" disabled v-if="current == 2 && item.fapiao_is_apply == 1 && item.fapiao_status == 1">已申领</el-button>
                    </template>
                    <template v-if="current == 3">
                      <el-button class="btn" v-if="current == 3 && item.zhengshu_is_apply == 0" @click="apply(item)">申领</el-button>
                      <el-button class="btn" disabled v-if="current == 3 && item.zhengshu_is_apply == 1 && item.zhengshu_apply_status == 0">申领中</el-button>
                      <el-button class="btn" v-if="current == 3 && item.zhengshu_is_apply == 1 && item.zhengshu_apply_status == 1" @click="lookzhengshu(item)"
                        >查看证书</el-button
                      >
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="article" v-show="current == 4">
          <h3 class="h3">志愿活动</h3>
          <div class="list">
            <div class="list-row" v-for="(item, index) in list" :key="index">
              <div class="wrap">
                <div class="title">{{ item?.jobs?.title }}</div>
                <div class="flex-space-between">
                  <div class="left">
                    <div class="row">
                      <div class="label">姓名：</div>
                      <div class="text">{{ item.name }}</div>
                    </div>
                    <div class="row">
                      <div class="label">性别：</div>
                      <div class="text">{{ item.sex_text }}</div>
                    </div>
                    <div class="row">
                      <div class="label">出生年月：</div>
                      <div class="text">{{ item.birthday }}</div>
                    </div>
                    <div class="row">
                      <div class="label">民族：</div>
                      <div class="text">{{ item.nation }}</div>
                    </div>
                    <!-- <div class="row">
                      <div class="label">活动时间：</div>
                      <div class="text">{{ item.pay_time_text }}</div>
                    </div> -->
                  </div>
                  <div class="right">
                    <!-- <el-button class="btn" disabled>申请中</el-button> -->
                    <el-button class="btn" @click="look">查看</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pagination" v-show="current !== 4">
          <el-pagination layout="slot" :total="total" :current-page="page" hide-on-single-page>
            <div>
              <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
                <i class="el-icon-arrow-left"></i>
                上一页
              </el-button>
              <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
                下一页
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="查看证书" width="500" center append-to-body>
      <div class="flex-center">
        <el-image :src="zhengshu_url" fit="fit" />
      </div>
    </el-dialog>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { baseURL } from "@/utils/http";
import { mapState } from "vuex";
import PCNavbar from "@/components/navbar/index";
import CarouselHome from "@/components/carousel_home/index";
import Footer from "@/components/footer/index";

export default {
  name: "PersonalCenter",
  components: {
    PCNavbar,
    CarouselHome,
    Footer,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      edit: false,
      current: 1,
      list: [],
      page: 1,
      total: 0,
      lastPage: 1,
      form: {
        nickname: "",
        avatar: "",
      },
      form1: {
        nickname: "",
        avatar: "",
      },
      uploadUrl: `${baseURL}/api/common/upload`,
      fileList: [],
      dialogVisible: false,
      zhengshu_url: "",
      carouselHeight: 0,
    };
  },
  created() {
    this.getListData();
  },
  mounted() {
    this.form1.nickname = this.userInfo.nickname;
    this.form1.avatar = this.userInfo.avatar;
    this.form1.username = this.userInfo.username;
    this.$nextTick(() => {
      this.carouselHeight = this.$refs.carouselHomeRef.$el.offsetHeight + "px";
    });
  },
  methods: {
    toggle(index) {
      this.current = index;
      this.page = 1;
      this.list = [];
      if (index < 4) {
        this.getListData();
      } else {
        this.getListData2();
      }
    },
    async getListData() {
      const res = await CifuAPI.getDonateList({ is_mylog: 1, page: this.page, limit: 10 });
      if (res.code == 1) {
        this.list = res.data.data;
        this.total = res.data.total;
        this.lastPage = res.data.last_page;
      }
    },
    async getListData2() {
      const res = await CifuAPI.applyList({ job_type: 2 });
      if (res.code == 1) {
        this.list = res.data;
      }
    },
    handlePrevChange() {
      this.page--;
      this.getListData();
    },
    handleNextChange() {
      this.page++;
      this.getListData();
    },
    look() {
      this.$router.push(`/joinUs?type=2`);
    },
    handleEdit() {
      this.edit = true;
    },
    // 上传前验证
    beforeUpload(file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
      const isValidType = validTypes.includes(file.type);
      const isValidSize = file.size / 1024 / 1024 < 30;

      if (!isValidType) {
        this.$message.error("只能上传 JPG/JPEG/PNG 格式的图片!");
        return false;
      }

      if (!isValidSize) {
        this.$message.error("图片大小不能超过 30MB!");
        return false;
      }

      return true;
    },

    // 通用删除处理
    handleRemove() {
      this.fileList = [];
      this.form.photo = ""; // 清空照片路径
    },

    // 通用上传成功处理
    handleSuccess(res) {
      if (res.code == 1) {
        this.form1.avatar = res.data.fullurl; // 赋值照片路径
      } else {
        this.$message.error("上传失败，请重试");
      }
    },
    async apply(item) {
      this.$router.push(`/donate/${this.current + 1}?flow_number=${item.flow_number}`);
    },
    lookzhengshu(item) {
      this.dialogVisible = true;
      this.zhengshu_url = item.zhengshu_text;
    },
    async handleSubmit() {
      const data = JSON.parse(JSON.stringify(this.form1));
      const res = await CifuAPI.updateUserInfo(data);
      if (res.code == 1) {
        this.$message.success("修改成功");
        this.userInfo.avatar = data.avatar;
        this.userInfo.nickname = data.nickname;
        CifuAPI.getUserInfo().then((res) => {
          if (res.code == 1) {
            this.$store.dispatch("setUserInfo", res.data);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pageView{
  width: 100%;
  min-width: 1400px;
}
.article {
  .h3 {
    padding-top: 10px;
    font-size: 28px;
    color: #663301;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      padding-top: 0;
      font-size: 16px;
    }
  }
  .list {
    padding-top: 0;
    @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
      gap: 0;
    }
    &-row {
      padding: 30px 0;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        width: 100%;
        padding: 10px 0;
      }
      .title {
        padding-bottom: 12px;
        color: #663301;
        @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          padding-bottom: 0;
        }
      }
    }
    .wrap {
      width: 100%;
    }
    .left {
      flex: 1;
      .row {
        display: flex;
        align-items: center;
        margin-top: 12px;
        font-size: 18px;
        color: #4f4f4f;
        @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          margin-top: 6px;
          font-size: 12px;
        }
        .label {
          width: 90px;
          text-align: justify;
          text-align-last: justify;
          @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
            width: 60px;
          }
        }
      }
    }
    .right {
      ::v-deep .is-disabled {
        color: #663301;
      }
      .btn {
        @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          width: 80px;
          height: 30px;
          padding: 0;
        }
      }
    }
  }
}
.mask {
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 2;
  width: 100%;
  height: 460px;
  background: rgba(243, 230, 175, 0.8);
  @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    height: 125px;
    top: 0px;
  }
  .block-wrap {
    height: 100%;
  }
  .person {
    .head {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 3;
      width: 150px;
      height: 150px;
      margin-bottom: 24px;
      background: #fff;
      border-radius: 50%;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        width: 60px;
        height: 60px;
        margin: 0 auto 10px;
      }
      .avatar {
        width: 80%;
        height: 80%;
        border-radius: 50%;
        margin-bottom: 10px;
      }
      .edit {
        position: absolute;
        right: 0;
        bottom: 0;
        z-index: 4;
        width: 30px;
        height: 30px;
        @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
          width: 20px;
          height: 20px;
          right: -5px;
          bottom: -5px;
        }
        &-icon {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .info {
      margin-bottom: 16px;
      font-size: 18px;
      color: #000;
      text-align: center;
      @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
        margin-bottom: 0;
        font-size: 12px;
      }
    }
  }
}
.custom-btn-group {
  padding-left: 50px;
  padding-bottom: 70px;
  .btn {
    width: auto;
  }
}
</style>
